import Vue from 'vue'
import Vuex from 'vuex'

// Vuex app global
import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

// Vuex modules
import CustomerNew from 'shared/modules/CustomerNew/vuex/store'
import Loading from 'shared/modules/Loading/vuex/store'
import Result from 'residential/modules/Result/vuex/store'

Vue.use(Vuex)

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {
        // Default
        CustomerNew,
        Loading,
        // Modules
        Result
    }
})


// WEBPACK FOOTER //
// ./src/enterprise/vuex/store.js